import { render, staticRenderFns } from "./wornList.vue?vue&type=template&id=676a3a15&scoped=true&"
import script from "./wornList.vue?vue&type=script&lang=js&"
export * from "./wornList.vue?vue&type=script&lang=js&"
import style0 from "./wornList.vue?vue&type=style&index=0&id=676a3a15&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676a3a15",
  null
  
)

export default component.exports